export default "__VITE_ASSET__DTfhixIJ__"